import { render } from "./TailwindSelect.vue?vue&type=template&id=9b100d68"
import script from "./TailwindSelect.vue?vue&type=script&lang=js"
export * from "./TailwindSelect.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Dev\\Personal\\reethi-inertia\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__